import React, { SetStateAction } from 'react';
import Toggle from 'components/common/toggle';

type Props = {
  row: any;
  columnId: string;
  value: boolean;
  setTableData: React.Dispatch<any>;
  onEdit: (newValue: boolean, row: any) => void;
};

const EditableToggleCell = ({ row, value, columnId, setTableData, onEdit }: Props) => {
  const handleChange = (newValue: SetStateAction<boolean>) => {
    console.log('Handling Change');
    const newValueBool = typeof newValue === 'function' ? newValue(value) : newValue;
    setTableData((prev: any) => ({
      ...prev,
      items: prev.items.map((item: any) => {
        if (item.id === row.id) {
          return { ...item, [columnId]: newValue };
        }
        return item;
      })
    }));

    onEdit(newValueBool, row);
  };

  return (
    <div className="editable-toggle-cell">
      <Toggle value={value} onChange={handleChange} />
    </div>
  );
};

export default EditableToggleCell;
